import { ContentLoader, IReactBaseProps } from '@gcl/react-core';
import * as React from 'react';

export interface ITableContentLoaderProps extends IReactBaseProps {
  isLoading?: boolean;
}

export const TableContentLoader: React.FunctionComponent<ITableContentLoaderProps> = ({ children, isLoading }) => {
  const active = React.useMemo(() => {
    return isLoading === undefined || isLoading;
  }, [isLoading]);

  const paragraphConfigs = React.useMemo(() => {
    return [
      { suffixBlankRow: true, numberOfRows: 1, lineHeight: 20 },
      { suffixBlankRow: true, numberOfRows: 20, lineHeight: 10 },
    ];
  }, []);

  return (
    <ContentLoader active={active} linePadding={10} paragraphConfigs={paragraphConfigs}>
      {children}
    </ContentLoader>
  );
};
